/**
 * Web Audio equalizer routes `<audio>` through AudioContext. Mobile OSs suspend that
 * graph when the screen locks, which stops playback. Use plain media element there.
 */
export function shouldUseWebAudioEqualizer() {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') return true;

  const ua = String(navigator.userAgent || '');
  const ios =
    /iPad|iPhone|iPod/i.test(ua) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  if (ios) return false;

  const coarsePointer = window.matchMedia?.('(pointer: coarse)').matches;
  const narrowViewport = window.matchMedia?.('(max-width: 960px)').matches;
  if (/Android/i.test(ua) && (coarsePointer || narrowViewport)) return false;

  return true;
}
